<ng-template
  let-extraClass="extraClass"
  #topNav>
  @if (!isRightSideContent) {
    <tidy-top-nav
      [class]="extraClass"
      [title]="'Send for E-Signature'"
      [canGoBack]="!windowService.isDesktopRes" />
  }
</ng-template>

<ng-container *ngTemplateOutlet="topNav;context:{ extraClass: 'mobile' }" />

<ng-template #content>
  <tidy-wrapper [class]="isRightSideContent ? 'right-side-scroll-enabled' : ''">

    @if (loaded) {
      <tidy-card>
        <form [formGroup]="form" novalidate action="#">
          <tidy-row>
            <tidy-input
              [label]="'Recipient Name'"
              formControlName="recipientName"
              [form]="form.controls.recipientName"
              [icon]="'assets/svg/person-outline.svg'"
              [submitted]="submitted"
              [errorMessage]="'Please enter a name'" />
          </tidy-row>
          <tidy-row>
            <tidy-input
              [label]="'Recipient Email'"
              formControlName="recipientEmail"
              [form]="form.controls.recipientEmail"
              [icon]="'assets/svg/mail-outline.svg'"
              [type]="'email'"
              [submitted]="submitted"
              [errorMessage]="'Please enter a valid email'" />
          </tidy-row>
        </form>
      </tidy-card>
      <tidy-button
        [text]="'Send'"
        [action]="sendAction"
        class="primary" />
      @if (errorMessage) {
        <tidy-error-message
          [text]="errorMessage" />
      }
    }
  </tidy-wrapper>
</ng-template>

@if (!isRightSideContent) {
  <app-scroll-wrapper [templateContent]="content" />
}

@if (isRightSideContent) {
  <ion-content class="ion-content-right-column">
    <ng-container *ngTemplateOutlet="content" />
  </ion-content>
}
